import React, { useEffect, useState } from 'react'
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import './style.scss'
import brok from 'brokjson'

function AnimatedMap(props) {
  const [mapObject, setMapObject] = useState(null)

  useEffect(() => {
    const map = new mapboxgl.Map({
      container: 'map',
      style: require('./style.json'),
      center: [8.6557, 47.4172],
      zoom: 10,
      maxZoom: 15,
      minZoom: 8,
      interactive: true
    })

    // Return map object
    props.getMapObject(map)

    setMapObject(map)

    // Add controls
    const navigationControl = new mapboxgl.NavigationControl({
      showCompass: false
    })

    map.addControl(navigationControl, 'top-right')

    // Initial adjustments
    map.once('load', () => {
      props.mapReady(map)

      // map.addSource('data', {
      //   type: 'geojson',
      //   data: { type: 'FeatureCollection', features: [] }
      // })

      map.addSource('data', {
        type: 'geojson',
        data: brok.brok2geo(require('../data/data.brokjson'))
      })

      map.addLayer({
        id: 'data',
        type: 'circle',
        source: 'data',
        paint: {
          'circle-radius': {
            base: 1,
            stops: [
              [6, 1],
              [18, 85]
            ]
          },
          'circle-color': '#1d5f82',
          'circle-opacity': 0,
          'circle-stroke-width': 3,
          'circle-stroke-color': '#1d5f82'
        }
      })

      map.addSource('active', {
        type: 'geojson',
        data: { type: 'FeatureCollection', features: [] }
      })

      map.addLayer({
        id: 'active',
        type: 'circle',
        source: 'active',
        paint: {
          'circle-radius': {
            base: 1,
            stops: [
              [6, 1],
              [18, 85]
            ]
          },
          'circle-color': '#c22b16',
          'circle-opacity': 0,
          'circle-stroke-width': 5,
          'circle-stroke-color': '#c22b16'
        }
      })

      // Fit Map
      map.fitBounds(
        [
          [8.34, 47.15],
          [9.0, 47.71]
        ],
        { duration: 0 }
      )

      // On Load Callback
      if (props.onLoad) {
        props.onLoad()
      }
    })
  }, [])

  return (
    <>
      <div id='map'>{props.children}</div>
    </>
  )
}

export default AnimatedMap
